import EntityDetailsProvider from '@shared/components/details/entity-details-provider/entity-details-provider.vue';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import moment from 'moment';
const PostTable = () => import('@cms/components/tables/post-table/post-table.vue');
const ResourceTable = () => import('@centers/components/tables/resource-table/resource-table.vue');
import { Post } from '@cms/interfaces/post';
import DisciplineTable from '@centers/components/tables/discipline-table/discipline-table.vue';
import ActivityTable from '@activities/components/tables/activity-table/activity-table.vue';
import SubscriptionCategoryTable
  from "@subscriptions/components/tables/subscription-category-table/subscription-category-table.vue";

@Component({
  name: 'bpc-post-details',
  components: {
    'bpc-entity-details-provider': EntityDetailsProvider,
    'bpc-post-table': PostTable,
    'bpc-resource-table': ResourceTable,
    'bpc-discipline-table': DisciplineTable,
    'bpc-activity-table': ActivityTable,
    'bpc-subscription-category-table': SubscriptionCategoryTable
  },
})
export default class PostDetails extends Vue {
  @Prop(String) readonly entity: string;
  @Prop(Number) readonly entityId: number;
  @Prop(String) readonly fetchPath: string;
  @Prop(String) readonly alias: string;

  constructor() {
    super();
  }

  archiveDisplayConfigName: string = 'archive';
  archiveFilterConfigName: string = 'archive';

  selectConfigName(post): string[] {
    if (this.postIsType(post, 'archive_of_subscriptions')) {
      return ['part1', 'part2'];
    } else {
      return null;
    }
  };
  customFiltersToApply(post) {
    // DEPRECATED
    // const filters = post?.custom_filter?.filters;
    // console.log('filters', filters);
    // if (!filters) {
    //   return [];
    // }
    // return Object.keys(filters).map(key => {
    //   return {
    //     filterField: key,
    //     value: filters[key],
    //   };
    // });

    const params = [];

    //Commons
    const orderBy = post?.display_options?.order_by;
    if (orderBy) {
      params.push({ filterField: 'orderBy', value: orderBy });
    }
    const orderDirection = post?.display_options?.order_direction;
    if (orderDirection) {
      params.push({ filterField: 'orderDirection', value: orderDirection });
    }

    const perPage = post?.display_options?.posts_per_page;
    if (perPage) {
      params.push({ filterField: 'per_page', value: perPage });
    }

    //Specifics
    //Post
    if (this.postIsType(post, 'archive_of_posts')) {
      const author_id = post?.filters_apply_options?.author_id;
      if (author_id) {
        params.push({ filterField: 'author_id', value: author_id });
      }
      const post_category_ids = post?.filters_apply_options?.post_category_ids;
      if (post_category_ids) {
        params.push({ filterField: 'post_category_ids', value: post_category_ids });
      }
    }
    //Disciplines
    if (this.postIsType(post, 'archive_of_disciplines')) {
      const discipline_resource = post?.filters_apply_options?.discipline_resource;
      if (discipline_resource) {
        params.push({ filterField: 'resources__id', value: discipline_resource });
      }
    }
    //Resources
    if (this.postIsType(post, 'archive_of_resources')) {
      const resource_type = post?.filters_apply_options?.resource_type;
      if (resource_type) {
        params.push({ filterField: 'type', value: resource_type });
      }
      const resource_discipline = post?.filters_apply_options?.resource_discipline;
      if (resource_discipline) {
        params.push({ filterField: 'disciplines__id', value: resource_discipline });
      }
      const resource_sector = post?.filters_apply_options?.resource_sector;
      if (resource_sector) {
        params.push({ filterField: 'sectors__id', value: resource_sector });
      }
    }

    //Activities
    if (this.postIsType(post, 'archive_of_activities')) {
      const activity_type = post?.filters_apply_options?.activity_type;
      if (activity_type) {
        params.push({ filterField: 'activity_type', value: activity_type });
      }

      const activity_discipline = post?.filters_apply_options?.activity_discipline;
      if (activity_discipline) {
        params.push({ filterField: 'disciplines__id', value: activity_discipline });
      }

      const activity_category = post?.filters_apply_options?.activity_category;
      if (activity_category) {
        params.push({ filterField: 'activityCategory__id', value: activity_category });
      }

      const start_date_from = post?.filters_apply_options?.start_date_from;
      if (start_date_from) {
        params.push({ filterField: 'start_date_from', value: start_date_from });
      }

      const start_date_to = post?.filters_apply_options?.start_date_to;
      if (start_date_to) {
        params.push({ filterField: 'start_date_to', value: start_date_to });
      }
    }

    if (this.postIsType(post, 'archive_of_online_trainings')) {
      params.push({filterField: 'activity_type' , value: 'learning'})
    }


    //Subscriptions
    if (this.postIsType(post, 'archive_of_subscriptions')) {
      const subscription_type = post?.filters_apply_options?.subscription_type;
      if (subscription_type) {
        params.push({ filterField: 'type', value: subscription_type });
      }
      const subscription_discipline = post?.filters_apply_options?.subscription_discipline;
      if (subscription_discipline) {
        params.push({ filterField: 'disciplines__id', value: subscription_discipline });
      }
    }

    return params;
  }

  get aliasName(): string {
    return this.alias || 'homepage';
  }

  get fetchPathRoute(): string {
    if (this.entityId) {
      return this.fetchPath || 'posts/' + this.entityId + '/details';
    }
    return 'posts/details/' + this.aliasName;
  }

  showCategoryFilter(post: Post): boolean {
    const tenant = this.$authService.getSelectedTenant();
    return (
      this.postIsType(post, 'archive_of_activities') &&
      !!tenant.center_setting.show_activity_categories_in_profile
    );
  }
  categoryFilterConfigName(post: Post): string {
    return this.postIsType(post, 'archive_of_activities') ? 'activity-category' : '';
  }

  formatTime(item) {
    return moment(item).format('DD/MM/YYYY H:m');
  }

  public postIsType(item: Post, type: string) {
    return item?.type_value?.includes(type);
  }
  public componentName(post: Post): string {
    if (this.postIsType(post, 'archive_of_posts')) {
      return 'bpc-post-table';
    } else if (this.postIsType(post, 'archive_of_resources')) {
      return 'bpc-resource-table';
    } else if (this.postIsType(post, 'archive_of_disciplines')) {
      return 'bpc-discipline-table';
    } else if (this.postIsType(post, 'archive_of_activities')) {
      return 'bpc-activity-table';
    } else if (this.postIsType(post, 'archive_of_online_trainings')) {
      return 'bpc-activity-table';
    } else if (this.postIsType(post, 'archive_of_subscriptions')) {
      return 'bpc-subscription-category-table';
    }
    return 'bpc-post-table';
  }

  formatDateTime(datetime) {
    if (datetime) {
      return moment(String(datetime)).format('DD/MM/YYYY hh:mm');
    }
    return '';
  }
}
